
















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import Query from '../../../components/query/queryHeard.vue'
import addModal from './addModal.vue'
import detail from './detail.vue'
import {QueryMaterials,QuerySysDic} from '../../../api/material'
import {QueryManufacturer,CreateManufacturer,EditManufacturer} from '../../../api/basicDictionary'
import {QueryTenant,QueryPurPurchaseReceiptList} from '../../../api/shipmentsManagement'
import util from '../../../lib/util'
@Component({
  components:{myTable,Query,addModal,detail}
})
export default class extends AbpBase{
    
    list:Array<object> = []
    addModalShow:boolean = false
    addModalData:object = null

    detailModalShow:boolean = false
    detailModalData:object = null

    
    conditions:any = []
    created() {
        this.getData()   
        this.getSelects()
    }
    //获取条件下拉框
    async getSelects(){
        this.conditions = [
            {
                name:'receiptNo',
                dataType:1,
                value:null,
                label:'采购单号',
            },
            {
                name:'goodsTypeId',
                dataType:6,
                value:null,
                label:'采购类型',
                options:((await QuerySysDic({dataType:1,status:true,typeName:''})).data).map((item:any)=>{
                    return {
                        value:item.id,
                        text:item.typeName,
                    }
                })
            },
            {
                name:'purchaseDate',
                dataType:3,
                value:null,
                label:'采购日期',
            },
            {
                name:'tenantId',
                dataType:6,
                value:null,
                label:'中心',
                options:((await QueryTenant({queryString:'',pageSize:10000,page:1})).data).map((item:any)=>{
                    return {
                        value:item.tenantId,
                        text:item.name,
                    }
                })
            },
        ]
    }
    async getData(){
        this.table.loading = true
        let search = {}
        this.conditions.forEach((item:any)=>{
            if(item.value){
                search[item.name] = item.value
            }
        })
        let data = {
            ...search,
            ...this.table
        }
        let res = await QueryPurPurchaseReceiptList(data)
        this.table.totalCount = res.data.totalCount;
        this.list = res.data.items.map(item=>{item.purchaseDate = util.formatTime(item.purchaseDate);return item});
        this.table.loading = false
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    detail(row:any){
        this.detailModalData = row
        this.detailModalShow = true
    }
    add(row:any){
        this.addModalData = row
        this.addModalShow = true
    }
    columns:Array<object> = [
        {title:'采购单号',key:'receiptNo'},
        {title:'采购类型',key:'goodsType'},
        {title:'采购日期',key:'purchaseDate'},
        {title:'采购人',key:'originatorName'},
        {title:'供货商',key:'supplierName'},
        {title:'中心',key:'tenantName'},
        {title:'状态',key:'statusName'},
        {
            title:'操作',
            width:'160',
            render:(h:any,p:any)=>{
                return h('div',[
                    h('el-button',{
                        props:{
                            type:'text',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                               this.detail(p.row)
                            }
                        }
                    },'详情'),
                    h('el-button',{
                        props:{
                            type:'text',
                            size:'small'
                        },
                        on:{
                            click:()=>{
                               this.add(p.row)
                            }
                        }
                    },'发货')
                ])
            }
        },
    ]
}
